export function fileDownloadFromBlob (blob, filename) {
  const href = URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = href
  link.setAttribute("download", filename)
  link.click()
  URL.revokeObjectURL(href)
}
